// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入首页组件（路径正确）
const HomePage = () => import('../views/HomePage.vue')
const CaseStudyPage = () => import('../views/CaseStudyPage.vue')
const NewsPage = () => import('../views/NewsPage.vue')
const AboutPage = () => import('../views/AboutPage.vue')
const NewsDetailPage = () => import('../views/NewsDetailPage.vue')
const RegisterPage = () => import('../views/RegisterPage.vue')
Vue.use(VueRouter)

const routes = [
    { path: '/', component: HomePage }, // 根路径指向首页
    { path: '/success', component: CaseStudyPage },
    { path: '/news', component: NewsPage },
    { path: '/about', component: AboutPage },
    { path: '/detail/:id', component: NewsDetailPage },
    { path: '/register', component: RegisterPage } 
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router